import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const DashboardEmptyState = ({
  color = colors.black,
  height = 192,
  isColorInherited = false,
  width = 256,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix width={width} height={height} viewBox="0 0 256 192" {...props}>
    <path
      d="M232,157h-11v11h-1v-11h-11v-1h11v-11h1v11h11V157z M188.1,159H40c-3.9,0-7-3.1-7-7V40c0-3.9,3.1-7,7-7h176c3.9,0,7,3.1,7,7
v84.1c0.3,0,0.7,0,1,0.1V40c0-4.4-3.6-8-8-8H40c-4.4,0-8,3.6-8,8v112c0,4.4,3.6,8,8,8h148.2C188.2,159.7,188.1,159.3,188.1,159z
 M220.5,130c-14.6,0-26.5,11.9-26.5,26.5s11.9,26.5,26.5,26.5s26.5-11.9,26.5-26.5S235.1,130,220.5,130 M220.5,129
c15.2,0,27.5,12.3,27.5,27.5c0,15.2-12.3,27.5-27.5,27.5S193,171.7,193,156.5C193,141.3,205.3,129,220.5,129L220.5,129z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
